<script setup lang="ts">
import { ref } from 'vue'

interface Props {
  content: string
  position?: 'top' | 'bottom' | 'left' | 'right'
}

const props = withDefaults(defineProps<Props>(), {
  position: 'top'
})

const isVisible = ref(false)

const positionClasses = {
  top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
  bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
  left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
  right: 'left-full top-1/2 transform -translate-y-1/2 ml-2'
}
</script>

<template>
  <div class="relative inline-block">
    <div
      @mouseenter="isVisible = true"
      @mouseleave="isVisible = false"
    >
      <slot />
    </div>

    <div
      v-if="isVisible"
      :class="[
        'absolute z-10 px-2 py-1 text-xs text-white bg-gray-900 rounded shadow-lg whitespace-nowrap',
        positionClasses[position]
      ]"
    >
      {{ content }}
      <div
        :class="[
          'absolute w-2 h-2 bg-gray-900 transform rotate-45',
          position === 'top' ? 'top-full left-1/2 -translate-x-1/2 -mt-1' : '',
          position === 'bottom' ? 'bottom-full left-1/2 -translate-x-1/2 -mb-1' : '',
          position === 'left' ? 'left-full top-1/2 -translate-y-1/2 -ml-1' : '',
          position === 'right' ? 'right-full top-1/2 -translate-y-1/2 -mr-1' : ''
        ]"
      />
    </div>
  </div>
</template>
